module.exports = __webpack_public_path__ + "static/media/ceilings_allImpact_60y_n.2479d017.csv";